// Copyright (c) 2024 UClone Inc.
// All rights reserved.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_UCLONE: null,
});
